// types
import { MatrixOption, MatrixAppetiteOption } from './types'
// utils
import { isNull } from 'lodash'

export const findMaxAppetite = (appetiteOptions: MatrixAppetiteOption[], matrixOptions: MatrixOption[]) => {
  let maxAppetite = null
  let maxValue = null
  let foundValidValue = false

  appetiteOptions.forEach((appetite) => {
    const optionId = appetite.matrixOptionId
    const match = matrixOptions.find((option) => option.id === optionId)

    if (match) {
      const numericValue = parseFloat(match.value)

      if (!isNaN(numericValue)) {
        foundValidValue = true

        if (isNull(maxValue) || numericValue > maxValue) {
          maxValue = numericValue
          maxAppetite = appetite
        }
      }
    }
  })

  return foundValidValue ? maxAppetite.id : null
}
